<template>
  <main-sidebar :name="name" :title="`${item.category_name} - ${item.year}` | capitalize" size="large">
    <vs-row class="px-2 mt-4">
      <vs-col vs-w="3" class="px-2">
        <statistics-card class="mb-base" icon="DollarSignIcon" title="USD" :statistic="getTotalColumn('usd')"
          color="#3498db" />
      </vs-col>
      <vs-col vs-w="3" class="px-2">
        <statistics-card class="mb-base" icon="DollarSignIcon" title="MXN" :statistic="getTotalColumn('mxn')" color="#28C76F" />
      </vs-col>
      <vs-col vs-w="3" class="px-2">
        <statistics-card class="mb-base" icon="DollarSignIcon" title="USD EST" :statistic="getTotalColumn('usd_est')"
          color="#FF9F43" />
      </vs-col>
      <vs-col vs-w="3" class="px-2">
        <statistics-card class="mb-base" icon="ClockIcon" title="LAST EXCHANGE RATE" :statistic="exchangerate"
          color="#BC1300" />
      </vs-col>
    </vs-row>

    <vs-row class="px-2">
      <vs-col vs-w="12">
        <vs-table :data="data">
          <template slot="thead">
            <vs-th>{{ $t('month') | capitalize }}</vs-th>
            <vs-th>{{ $t('exchange_rate') | capitalize }}</vs-th>
            <vs-th>{{ $t('USD') | capitalize }} </vs-th>
            <vs-th>{{ $t('MXN') | capitalize }} </vs-th>
            <vs-th>{{ $t('USD_EST') | capitalize }} </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].month" style="padding: 4px;">
                <vs-input class="w-full" :value="$t(data[indextr].month_name)" disabled />
              </vs-td>
              <vs-td :data="data[indextr].exchange_rate" style="padding: 4px;">
                <vs-input class="w-full" v-model="data[indextr].exchange_rate" @input="setUsdEst(indextr)" />
              </vs-td>
              <vs-td :data="data[indextr].totalUsd" style="padding: 4px;">
                <vs-input class="w-full" v-model="data[indextr].usd" @input="setUsdEst(indextr)" type="number" />
              </vs-td>
              <vs-td :data="data[indextr].totalMxn" style="padding: 4px;">
                <vs-input class="w-full" v-model="data[indextr].mxn" @input="setUsdEst(indextr)" type="number" />
              </vs-td>
              <vs-td :data="data[indextr].totalUsdEst" style="padding: 4px;">
                <vs-input class="w-full" :value="data[indextr].usd_est" type="number" disabled />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-col>
    </vs-row>

    <div class="px-4" slot="footer">
      <vs-button color="primary" type="filled" class="w-full" @click="update()">
        {{ $t('save') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import loading from '@/mixins/Loading'
import MainSidebar from '@/views/components/MainSidebar.vue'
import request from '../request.js'
import StatisticsCard from '@/views/components/StatisticsCard.vue'

export default {
  components: {
    MainSidebar,
    StatisticsCard,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    totalUsd() {
      return this.formatNumber(
        this.data.reduce((a, c) => Number(a) + Number(c.usd), 0),
        2
      )
    },
    totalMxn() {
      return this.formatNumber(
        this.data.reduce((a, c) => Number(a) + Number(c.mxn), 0),
        2
      )
    },
    totalUsdEst() {
      return this.formatNumber(
        this.data.reduce((a, c) => Number(a) + Number(c.usd_est), 0),
        2
      )
    }
  },
  data: () => ({
    data: [],
    exchangerate: 0,
    months: [
      { id: '1', name: 'january' },
      { id: '2', name: 'february' },
      { id: '3', name: 'march' },
      { id: '4', name: 'april' },
      { id: '5', name: 'may' },
      { id: '6', name: 'june' },
      { id: '7', name: 'july' },
      { id: '8', name: 'august' },
      { id: '9', name: 'september' },
      { id: '10', name: 'october' },
      { id: '11', name: 'november' },
      { id: '12', name: 'december' },
    ],
  }),
  mixins: [loading],
  methods: {
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    getData() {
      this.openLoading(`loading-${this.name}-sidebar`)
      const payload = {
        category_id: this.item.category_id,
        year: this.item.year,
        entity_id: this.item.entity_id,
        departament_id: this.item.departament_id,
      }
      request
        .budgetDetails(payload)
        .then((response) => {
          this.exchangerate = this.formatNumber(response.data.exchange_rate.ExchangeRate, 2)
          this.setData([...response.data.budgets])
          this.closeLoading(`loading-${this.name}-sidebar`)
        })
        .catch((error) => {
          this.closeLoading(`loading-${this.name}-sidebar`)
          this.showValidationErrors(error)
        })
    },
    getTotalColumn(column) {
      return this.data.length === 0 ? 0 : this.formatNumber(this.data.reduce((a, c) => Number(a) + Number(c[column]), 0), 2)
    },
    setValue(el,key){
      if(el === undefined){
        return null
      }else{
        return el[key] == '.00' ? '0.00' : el[key]
      }
    },
    setData(budgets) {
      const data = []
      this.months.forEach(month => {
        const el = budgets.find((el) => el.month == month.id)
        const item = {
          id: el !== undefined ? el.id : null,
          usd:this.setValue(el,'usd'),
          mxn:this.setValue(el,'mxn'),
          usd_est: this.setValue(el,'usd_est'),
          exchange_rate: el !== undefined ? this.formatNumber(el.exchange_rate, 2) : null,
          month_name: month.name,
          month_id: month.id
        }
        data.push(item)
      });
      this.data = [...data]
    },
    setUsdEst(idx) {
      if(this.data[idx].exchange_rate == 0 && this.data[idx].mxn == 0){
        this.data[idx].usd_est = 0
        return
      }
      const result = Number(this.data[idx].usd) + (Number(this.data[idx].mxn) / Number(this.data[idx].exchange_rate))
      this.data[idx].usd_est = result.toFixed(2)
    },
    update() {
      this.openLoading(`loading-${this.name}-sidebar`)
      const payload = {
        category_id: this.item.category_id,
        year: this.item.year,
        entity_id: this.item.entity_id,
        departament_id: this.item.departament_id,
        budgets: this.data.filter(el => (el.usd_est != null && el.exchange_rate != null && el.exchange_rate != 0))
      }
      request
        .budgetUpdate(payload)
        .then((response) => {
          this.closeLoading(`loading-${this.name}-sidebar`)
          this.close()
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Category Updated.',
          })
          this.$emit('refresh')
        })
        .catch((error) => {
          this.closeLoading(`loading-${this.name}-sidebar`)
          this.showValidationErrors(error)
        })
    },
  },
  props: {
    name: {
      type: String,
    },
    item: {
      type: Object,
      default: () => ({
        category_name: '',
        category_id: '',
        year: '',
        entity_id: '',
        departament_id: '',
      }),
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.getData()
      }
    },
  },
}
</script>

<style></style>